//used to prevent errors from being thrown
export const safelyParseInt = (number?: string | null) => {
  if (!number) return undefined;
  const isNumber = /^[0-9]+$/.test(number);
  return isNumber ? parseInt(number) : undefined;
};
